<div class="container-fluid loans-container">
  <div class="row m-3">
    <div class="page-header d-flex align-items-center mb-4">
    <div class="header-icon-bg">
      <mat-icon class="header-icon">search</mat-icon>
    </div>
    <div class="ml-3">
      <h1 class="page-title mat-h1 mb-0">Bitacora</h1>
      <p class="page-subtitle text-muted mb-0">Búsqueda de acciones de usuarios</p>
    </div>
  </div>
  </div>

  <div class="row no-gutters">
    <div class="col-lg-8 d-flex">
      <div class="card card-search w-100 h-100">
        <div class="card-body">
          <div class="row pl-3">
            <div class="col-12">
              <div class="d-flex align-items-center mb-3">
                  <mat-icon class="text-muted mr-2">tune</mat-icon>
                  <h5 class="section-label mb-0 text-muted">PARÁMETROS DE BÚSQUEDA</h5>
                </div>
            </div>
          </div>
          <div class="row">
            
            <div class="col-lg-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Acciones</mat-label>
                <mat-icon matPrefix class="mr-2 text-muted">description</mat-icon>
                <mat-select [(ngModel)]="actionSelected" required>
                  <mat-option *ngFor="let action of actions" [value]="action.id">{{action.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-4" *ngIf="actionSelected != 8 || !actionSelected">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Proveedor</mat-label>
                 <mat-icon matPrefix class="mr-2 text-muted">business</mat-icon>
                <mat-select required [(ngModel)]="partnerCode">
                  <mat-option *ngFor="let partner of partners"
                    [value]="partner.code">{{partner.name_product_format}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Usuario</mat-label>
                <mat-icon matPrefix class="mr-2 text-muted">account_circle</mat-icon>
                <input [(ngModel)]="userName" matInput placeholder="Nombre de usuario" value="">
              </mat-form-field>
            </div>
      
          </div>

          <div class="row">
            <div class="col-lg-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Numero de contrato</mat-label>
                <mat-icon matPrefix class="mr-2 text-muted">list_alt</mat-icon>
                <input [(ngModel)]="contractNumberCaptured" matInput placeholder="Numero de contrato ej. 12345-1" value="">
              </mat-form-field>
            </div>
          </div>
      
        </div>
      </div>

    </div>
    <div class="col-lg-4 d-flex">
      <div class="card card-search w-100 h-100">
        <div class="card-body">

          <div class="row">
            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Desde</mat-label>
                <input matInput [matDatepicker]="picker_from" placeholder="DD-MM-YYYY" [(ngModel)]="dateSelected.from">
                <mat-datepicker-toggle matSuffix [for]="picker_from"></mat-datepicker-toggle>
                <mat-datepicker #picker_from disabled="false"></mat-datepicker>
              </mat-form-field>
            </div>
      
            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Hasta</mat-label>
                <input matInput [matDatepicker]="picker_to" placeholder="DD-MM-YYYY" [(ngModel)]="dateSelected.to">
                <mat-datepicker-toggle matSuffix [for]="picker_to"></mat-datepicker-toggle>
                <mat-datepicker #picker_to disabled="false"></mat-datepicker>
              </mat-form-field>
            </div>
            
          </div>
          <div class="row">
            <div class="col-6 mt-3">
              <button mat-stroked-button  class="btn w-100 btn-search text-white " (click)="search()"> <mat-icon>search</mat-icon>  Buscar</button>
            </div>
            <div class="col-6 mt-3">
              <button mat-stroked-button  class="btn w-100 btn-clean" (click)="cleanSearch()"> <mat-icon>restart_alt</mat-icon>  Limpiar</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>




  <div class="row mt-5" *ngIf="rowsRecived.length > 0">
    <div class="table-responsive">
      <table class="table align-middle table-hover">
        <thead>
          <tr>
            <th scope="col" class="text-center fw-semibold text-secondary text-uppercase border-0 pb-3 px-3 th-label">
              Usuario</th>
            <th scope="col" class="text-center fw-semibold text-secondary text-uppercase border-0 pb-3 px-3 th-label">
              Accion</th>
            <th scope="col" class="text-center fw-semibold text-secondary text-uppercase border-0 pb-3 px-3 th-label">
              Fecha</th>
            <th scope="col" class="text-center fw-semibold text-secondary text-uppercase border-0 pb-3 px-3 th-label">Id
              de pago</th>
            <th scope="col" class="text-center fw-semibold text-secondary text-uppercase border-0 pb-3 px-3 th-label">
              Numero de contrato</th>
            <th scope="col" class="text-center fw-semibold text-secondary text-uppercase border-0 pb-3 px-3 th-label">
              Provedor</th>
            <th scope="col" class="text-center fw-semibold text-secondary text-uppercase border-0 pb-3 px-3 th-label">
              Detalle</th>
          </tr>
        </thead>
        <tbody *ngFor="let row of rowsRecived">
          <tr>
            <td class="text-center">{{row.name_user}}</td>
            <td class="text-center">{{row.action}}</td>
            <td class="text-center">{{row.created_at}}</td>
            <td class="text-center">{{row.payment_id ? row.payment_id : 'N/A' }}</td>
            <td class="text-center">{{row.contract_number ? row.contract_number : 'N/A' }}</td>
            <td class="text-center">{{row.provider_name ? row.provider_name : 'N/A'}}</td>
            <td class="text-left" style="min-width: 320px; white-space: normal;">{{row.additional_information ? row.additional_information : 'N/A'}}</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>

  <div class="row mt-3" *ngIf="rowsRecived.length > 0">
    <div class="col-lg-4 col-xs-12 col-md-12 mx-auto ">
      <div class="d-flex justify-content-center">
        <button *ngIf="historicalData.meta.previous_url" class="btn btn-sm m-2 page-item" (click)="moveIntoPages(historicalData.meta.previous_url)"> <i
            class="fa fa-angle-left" aria-hidden="true"> </i> Anterior </button>
        <button *ngIf="historicalData.meta.next_url" class="btn btn-sm  m-2 page-item" (click)="moveIntoPages(historicalData.meta.next_url)"> Siguiente <i
            class="fa fa-angle-right" aria-hidden="true"></i> </button>
      </div>
    </div>

  </div>
  <div class="row" *ngIf="rowsRecived.length > 0">
    <div class="col-12 d-flex justify-content-center">
      <p mt-2>Pagina {{historicalData.meta.page}} de {{historicalData.meta.size}}</p>
    </div>
  </div>
</div>